import connect from 'components/Shared/connect';
import Modal from 'components/Shared/Modal';
import { resetServerResponseError } from 'components/ErrorModal/actions';
import { rm } from 'utils';
import { PageState } from 'models/PageState';
import { PageError } from 'models/PageError';

interface MergedProps extends PageError {
  close: () => void;
}

const ErrorModal = ({ hasError, close, errorMessages }: MergedProps) => (
  <Modal show={hasError} onClose={close} showDefaultButton>
    <h3>{rm('dialogpopup_defaulttitle')}</h3>
    <ul>
      {errorMessages.map(error => (
        <li key={error}>{error}</li>
      ))}
    </ul>
  </Modal>
);

type StateProps = Pick<PageState, 'error'>;
export default connect<MergedProps & StateProps, Record<string, unknown>, StateProps>(
  state => ({
    error: state.error
  }),
  dispatch => ({
    close: () => dispatch(resetServerResponseError())
  }),
  ({ error, ...state }, dispatch) => ({
    ...state,
    ...dispatch,
    hasError: error.hasError,
    errorMessages:
      error.errorMessages.length > 0 ? error.errorMessages : [rm('error_generic_short')]
  })
)(ErrorModal);
